export default defineAppConfig({
  ui: {
    // primary: 'blue',
    // primary: 'azure-radiance',
    // primary: 'sky',
    primary: 'blue-ribbon',
    gray: 'neutral',
  }
})